import { render, staticRenderFns } from "./Anniu.vue?vue&type=template&id=6f36c4b6&"
import script from "./Anniu.vue?vue&type=script&lang=js&"
export * from "./Anniu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports